module.exports = __webpack_public_path__ + "img/05_Datos - ICONO.eb104894.png";